// extracted by mini-css-extract-plugin
export var modelsContainer = "CooperationModels-module--models-container--f17d6";
export var paddingContainerModels = "CooperationModels-module--padding-container-models--854ef";